import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import SearchOutlinedIcon from '@guildeducationinc/recess/icons/SearchOutlinedIcon';
import styles from './QuerySuggestionsItem.module.scss';
interface Props {
	item: { query: string };
	query: string;
}

export const QuerySuggestionsItem: React.FC<Props> = ({ item, query }) => {
	const parts = item.query.split(new RegExp(`(${query})`, 'gi'));

	return (
		<div className='aa-ItemWrapper'>
			<div className='aa-ItemContent'>
				<SearchOutlinedIcon className={styles.icon} size={24} />
				<Typography variant='body1'>
					{query === ''
						? item.query
						: parts.map(part => (
								<>
									<Typography
										weight={part.toLowerCase() === query.toLowerCase() ? 'bold' : 'normal'}
									>
										{part}
									</Typography>
								</>
							))}
				</Typography>
			</div>
		</div>
	);
};
